// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Jkzjj","notes":"Notes_notes__3teP4","note":"Notes_note__1WUaW","markdown":"Notes_markdown__3H0RN"};